// extracted by mini-css-extract-plugin
export default {"wrapper":"title-per-section_wrapper__yOAiC","label":"title-per-section_label__IKYD+","required":"title-per-section_required__epQox"};